module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "myDetail"
  }, [_c('mt-header', {
    attrs: {
      "title": _vm.title
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "left",
      "icon": "back"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    },
    slot: "left"
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "myTitle myWrap"
  }, [_c('div', {
    staticClass: "myImg"
  }, [_c('img', {
    attrs: {
      "src": _vm.httpUrl + _vm.userInfoData.photo
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "myInfo"
  }, [_c('div', [_c('span', {
    staticClass: "myName"
  }, [_vm._v(_vm._s(_vm.userInfoDataAccount.name))]), _vm._v(" "), (_vm.userInfoData.sex == '0') ? _c('icon', {
    attrs: {
      "name": "mars"
    }
  }) : _c('icon', {
    attrs: {
      "name": "venus"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "myWork"
  }, [_vm._v(_vm._s(_vm.userInfoData.position))]), _vm._v(" "), (_vm.realNameStatus) ? _c('span', {
    staticClass: "realname"
  }, [_vm._v("√实名认证")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "lineTwo"
  }, [_c('p', [_vm._v(_vm._s(_vm.userInfoData.cityName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.userInfoData.enterTypeName))]), _vm._v(" "), (_vm.userInfoData.experienceName != null && _vm.userInfoData.experienceName != '') ? _c('p', [_vm._v(_vm._s(_vm.userInfoData.experienceName) + "工作经验")]) : _vm._e(), _vm._v(" "), (_vm.userInfoData.salary != null) ? _c('p', [_c('span', [_vm._v(_vm._s(_vm.userInfoData.salary))]), _vm._v("元/天")]) : _vm._e(), _vm._v(" "), (_vm.positionTypeName != null) ? _c('div', {
    staticClass: "myLabels"
  }, _vm._l((_vm.positionTypeName), function(positionName, index) {
    return _c('span', {
      key: index
    }, [_vm._v(_vm._s(positionName))])
  }), 0) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "myWrap myEvaluate"
  }, [_c('div', {
    staticClass: "evaluate"
  }, [(this.evaluateInfo.star == 5) ? _c('div', {
    staticClass: "stars"
  }, [_c('icon', {
    attrs: {
      "name": "star"
    }
  }), _c('icon', {
    attrs: {
      "name": "star"
    }
  }), _c('icon', {
    attrs: {
      "name": "star"
    }
  }), _c('icon', {
    attrs: {
      "name": "star"
    }
  }), _c('icon', {
    attrs: {
      "name": "star"
    }
  })], 1) : (this.evaluateInfo.star == 4.5) ? _c('div', {
    staticClass: "stars"
  }, [_c('icon', {
    attrs: {
      "name": "star"
    }
  }), _c('icon', {
    attrs: {
      "name": "star"
    }
  }), _c('icon', {
    attrs: {
      "name": "star"
    }
  }), _c('icon', {
    attrs: {
      "name": "star"
    }
  }), _c('icon', {
    attrs: {
      "name": "star-half-o"
    }
  })], 1) : (this.evaluateInfo.star == 4) ? _c('div', {
    staticClass: "stars"
  }, [_c('icon', {
    attrs: {
      "name": "star"
    }
  }), _c('icon', {
    attrs: {
      "name": "star"
    }
  }), _c('icon', {
    attrs: {
      "name": "star"
    }
  }), _c('icon', {
    attrs: {
      "name": "star"
    }
  }), _c('icon', {
    attrs: {
      "name": "star-o"
    }
  })], 1) : (this.evaluateInfo.star == 3.5) ? _c('div', {
    staticClass: "stars"
  }, [_c('icon', {
    attrs: {
      "name": "star"
    }
  }), _c('icon', {
    attrs: {
      "name": "star"
    }
  }), _c('icon', {
    attrs: {
      "name": "star"
    }
  }), _c('icon', {
    attrs: {
      "name": "star-half-o"
    }
  }), _c('icon', {
    attrs: {
      "name": "star-o"
    }
  })], 1) : (this.evaluateInfo.star == 3) ? _c('div', {
    staticClass: "stars"
  }, [_c('icon', {
    attrs: {
      "name": "star"
    }
  }), _c('icon', {
    attrs: {
      "name": "star"
    }
  }), _c('icon', {
    attrs: {
      "name": "star"
    }
  }), _c('icon', {
    attrs: {
      "name": "star-o"
    }
  }), _c('icon', {
    attrs: {
      "name": "star-o"
    }
  })], 1) : (this.evaluateInfo.star == 2.5) ? _c('div', {
    staticClass: "stars"
  }, [_c('icon', {
    attrs: {
      "name": "star"
    }
  }), _c('icon', {
    attrs: {
      "name": "star"
    }
  }), _c('icon', {
    attrs: {
      "name": "star-half-o"
    }
  }), _c('icon', {
    attrs: {
      "name": "star-o"
    }
  }), _c('icon', {
    attrs: {
      "name": "star-o"
    }
  })], 1) : (this.evaluateInfo.star == 2) ? _c('div', {
    staticClass: "stars"
  }, [_c('icon', {
    attrs: {
      "name": "star"
    }
  }), _c('icon', {
    attrs: {
      "name": "star"
    }
  }), _c('icon', {
    attrs: {
      "name": "star-o"
    }
  }), _c('icon', {
    attrs: {
      "name": "star-o"
    }
  }), _c('icon', {
    attrs: {
      "name": "star-o"
    }
  })], 1) : (this.evaluateInfo.star == 1.5) ? _c('div', {
    staticClass: "stars"
  }, [_c('icon', {
    attrs: {
      "name": "star"
    }
  }), _c('icon', {
    attrs: {
      "name": "star-half-o"
    }
  }), _c('icon', {
    attrs: {
      "name": "star-o"
    }
  }), _c('icon', {
    attrs: {
      "name": "star-o"
    }
  }), _c('icon', {
    attrs: {
      "name": "star-o"
    }
  })], 1) : (this.evaluateInfo.star == 1) ? _c('div', {
    staticClass: "stars"
  }, [_c('icon', {
    attrs: {
      "name": "star"
    }
  }), _c('icon', {
    attrs: {
      "name": "star-o"
    }
  }), _c('icon', {
    attrs: {
      "name": "star-o"
    }
  }), _c('icon', {
    attrs: {
      "name": "star-o"
    }
  }), _c('icon', {
    attrs: {
      "name": "star-o"
    }
  })], 1) : (this.evaluateInfo.star == 0.5) ? _c('div', {
    staticClass: "stars"
  }, [_c('icon', {
    attrs: {
      "name": "star-half-o"
    }
  }), _c('icon', {
    attrs: {
      "name": "star-o"
    }
  }), _c('icon', {
    attrs: {
      "name": "star-o"
    }
  }), _c('icon', {
    attrs: {
      "name": "star-o"
    }
  }), _c('icon', {
    attrs: {
      "name": "star-o"
    }
  })], 1) : (this.evaluateInfo.star == 0) ? _c('div', {
    staticClass: "stars"
  }, [_c('icon', {
    attrs: {
      "name": "star-o"
    }
  }), _c('icon', {
    attrs: {
      "name": "star-o"
    }
  }), _c('icon', {
    attrs: {
      "name": "star-o"
    }
  }), _c('icon', {
    attrs: {
      "name": "star-o"
    }
  }), _c('icon', {
    attrs: {
      "name": "star-o"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("信誉度"), _c('span', [_vm._v(_vm._s(this.evaluateInfo.star))])]), _vm._v(" "), _c('p', [_vm._v("成交量"), _c('span', [_vm._v(_vm._s(this.evaluateInfo.turnover))])]), _vm._v(" "), _c('p', [_vm._v("评价数"), _c('span', [_vm._v(_vm._s(this.evaluateInfo.exCount))])]), _vm._v(" "), _c('p', [_vm._v("完成率"), _c('span', [_vm._v(_vm._s(this.evaluateInfo.Punctuality) + "%")])]), _vm._v(" "), _c('p', [_vm._v("完成质量"), _c('span', [_vm._v(_vm._s(this.evaluateInfo.quality) + "%")])]), _vm._v(" "), _c('p', [_vm._v("满意度"), _c('span', [_vm._v(_vm._s(this.evaluateInfo.Satisfaction) + "%")])])]), _vm._v(" "), _c('div', {
    staticClass: "evaluateLabel"
  }, _vm._l((_vm.evaluateLabel), function(evaluateLabel, index) {
    return _c('span', {
      key: index
    }, [_vm._v(_vm._s(evaluateLabel.appraiseLabel))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "myWrap goodSkill"
  }, [_c('p', [_vm._v("擅长技能")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, _vm._l((_vm.skillsName), function(skillName, index) {
    return _c('span', {
      key: index
    }, [_vm._v(_vm._s(skillName))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "myWrap myIntroduce"
  }, [_c('p', [_vm._v("我的简介")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.userInfoData.aboutMe))])]), _vm._v(" "), _c('div', {
    staticClass: "myCase myWrap"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("我的案例")]), _vm._v(" "), _vm._l((_vm.workList), function(workList, index) {
    return _c('div', {
      key: index,
      staticClass: "caseList"
    }, [_c('mt-swipe', {
      attrs: {
        "auto": 4000
      }
    }, _vm._l((workList.workPhotoList), function(workPhoto, index) {
      return _c('mt-swipe-item', {
        key: index
      }, [_c('img', {
        staticStyle: {
          "width": "100%",
          "height": "100%"
        },
        attrs: {
          "src": _vm.httpUrl + workPhoto.resAddr
        }
      })])
    }), 1), _vm._v(" "), _c('div', {
      staticClass: "caseWrap"
    }, [_c('h1', [_vm._v(_vm._s(workList.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(workList.industryName))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "line-height": "10px"
      }
    }, [_vm._v(_vm._s(workList.obligation))]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(workList.description))]), _vm._v(" "), _c('a', {
      attrs: {
        "href": workList.link
      }
    }, [_vm._v(_vm._s(workList.link))])])], 1)
  })], 2), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("Copyright @ by Yunzhitu.com - xxx")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a25ef376","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/myDetail.vue
// module id = 1293
// module chunks = 1